import { type TileData, type Edges, Terrain, Animal, EdgeType, Direction } from "./types"
import { EDGE_PATTERNS } from "./constants"

export class Tile {
  terrain: Terrain
  animal: Animal | null
  baseEdges: Edges
  rotation: number // 0–3 quarter turns

  constructor(data: TileData) {
    this.terrain = data.terrain
    this.animal = data.animal
    this.baseEdges = { ...data.baseEdges }
    this.rotation = data.rotation
  }

  static create(terrain: Terrain, animal: Animal | null, edgePattern: string): Tile {
    const edges = EDGE_PATTERNS[edgePattern]
    if (!edges) throw new Error(`Unknown edge pattern: ${edgePattern}`)
    return new Tile({ terrain, animal, baseEdges: edges, rotation: 0 })
  }

  /** Get effective edge after rotation: rotatedEdge[D] = baseEdge[(D - R + 4) % 4] */
  getEdge(direction: Direction): EdgeType {
    const baseDir = ((direction - this.rotation + 4) % 4) as Direction
    return this.baseEdges[baseDir]
  }

  get edges(): Edges {
    return {
      [Direction.N]: this.getEdge(Direction.N),
      [Direction.E]: this.getEdge(Direction.E),
      [Direction.S]: this.getEdge(Direction.S),
      [Direction.W]: this.getEdge(Direction.W),
    }
  }

  rotate(quarterTurns: number = 1): void {
    this.rotation = (this.rotation + quarterTurns) % 4
  }

  removeAnimal(): Animal | null {
    const animal = this.animal
    this.animal = null
    return animal
  }

  clone(): Tile {
    return new Tile({
      terrain: this.terrain,
      animal: this.animal,
      baseEdges: { ...this.baseEdges },
      rotation: this.rotation,
    })
  }
}
